$(function () {
  if($('.js-flg_taxi_ticket-wrap').length) {
    // 読み込んだ時の処理
    $('.js-flg_taxi_ticket-wrap').hide();
    if($('input[name=flg_taxi_ticket]:checked').val() == 2 || $('input[name=flg_taxi_ticket]').val() == 'Y') {
      $('.js-flg_taxi_ticket-wrap').show();
    }
    // 「あり」にチェックを入れた時の処理
    $(document).on('change', 'input[name="flg_taxi_ticket"]', function(){
      var val = $(this).val();
      if(val == 2 || val == 'Y') {
        $('.js-flg_taxi_ticket-wrap').fadeIn();
      }else{
        $('.js-flg_taxi_ticket-wrap').fadeOut();
        $('.js-flg_taxi_ticket-wrap input').val('');
      }
    });
  }
  if($('.js-flg_indoor_care-wrap').length) {
    // 読み込んだ時の処理
    $('.js-flg_indoor_care-wrap').hide();
    if($('input[name=flg_indoor_care]:checked').val() == 2 || $('input[name=flg_indoor_care]').val() == 'Y') {
      $('.js-flg_indoor_care-wrap').show();
    }
    // 「要」にチェックを入れた時の処理
    $(document).on('change', 'input[name="flg_indoor_care"]', function(){
      var val = $(this).val();
      if(val == 2 || val == 'Y') {
        $('.js-flg_indoor_care-wrap').fadeIn();
      }else{
        $('.js-flg_indoor_care-wrap').fadeOut();
        $(".js-flg_indoor_care-wrap option:selected").prop("selected", false);
      }
    });
  }
});